import { AppData, Log } from '@lightningjs/sdk'
import { ACTIONTYPE, DRM_TYPE, PLATFORM } from './enum'
import { AppSetup } from './app-setup'
import { Logger } from './logger'
import Router from '@lightningjs/sdk/src/Router'
import RowList from './components/grid/row-model'
import { fetchData, getDRMSERVICEURL, getDRMURL } from './models/data-service'



export class Helper {

    /**
     * trims spaces from start & end for the given text used in search text.
     *
     * @static
     * @param {*} input
     * @returns {*}
     */
    static trimSearchString(input: any) {
        const trim = input.replace(/(^\s+|\s+$)/gm, '');
        return trim;
    }

    static getRowStyle(rowList: RowList | null = null): { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } {
        const { appState, appConfig } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()
        let gridstyle = appApiConfig?.appConfig.gridstyle
        if (rowList && rowList.rowstyle) {
            gridstyle = rowList.rowstyle
        }
        const isCarouselType = appConfig?.enableMidCarousel && (rowList?.row_type === 'carousel' || rowList?.row_type === 'non-click')
        if(isCarouselType){
            return {
                row_height: 500 + 15,
                row_item_height: 450,
                row_item_width: 800,
                rowstyle: "two-row-flat-landscape-custom"
            }
        }
        if (gridstyle == 'two-row-flat-landscape-custom') {
            return {
                row_height: 240 + 54,
                row_item_height: 204,
                row_item_width: 362,
                rowstyle: "two-row-flat-landscape-custom"
            }
        } else {
            return {
                row_height: 292 + 54,
                row_item_height: 292,
                row_item_width: 227,
                rowstyle: "flat-movie",
            }
        }
    }

    static interactionTime = 0
    static debouneInterval = 500 //ms
    static isCurrentPage(pages: string[]) {
        const currentRoute = Router.getActiveRoute()!
        const res = pages.find(page => {
            const isMenuFocused = Router.getActivePage()?.isMenuFocused
            if (isMenuFocused) {
                return (page == 'menu')
            } else {
                return currentRoute.indexOf(page) >= 0
            }
        })
        if (res) {
            return true
        }
        return false
    }

    static checkInteractionTime(): boolean {
        const timestamp = new Date().getTime()
        if ((Helper.interactionTime + Helper.debouneInterval) > timestamp) {
            return false
        } else {
            Helper.interactionTime = timestamp
        }
        return true
    }

    static urlParam = (name: string, url: string) => {
        const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url)
        if (results == null) {
            return ''
        } else {
            return results[1] || 0
        }
    }

    static toBoolean = (value: any, defauleValue = false) => {
        return (value == 'true' || value == true) ? true : ((value == 'false' || value == false) ? false : defauleValue)
    }

    static toNumber = (value: any, defauleValue: number | undefined) => {
        return value == null || value == '' ? defauleValue : parseFloat(value)
    }

    static getAppStoreId = (obj: any, platform_id: string) => {
        switch (platform_id) {
            case PLATFORM.VIZIO:
                return ''
            case PLATFORM.LG:
                return ''
            default:
                return ''
        }
    }

    /**
    * @method isAdultContent
    * @description Check if the content is adult content based on the "age_appropriate_rating" property.
    * @param {object} vodInfo - The video on demand information object.
    * @returns {boolean} - Returns true if the content is adult content, false otherwise.
    */
    static isAdultContent = (vodInfo) => {
        return ['R', '18+', 'TV-MA'].includes(vodInfo?.age_appropriate_rating)
    }

    /**
     * Combines rgb hex string and alpha into argb hexadecimal number
     * @param {string|number} hex - 6 alphanumeric characters between 0-f or argb hexadecimal number
     * @param {number} [alpha] - number between 0-1 (0 is invisible, 1 is opaque)
     */
    static getHexaColor = (hex: any, alpha: any = 1) => {
        if (!hex) {
            return 0x00;
        }

        if (typeof hex === 'number') {
            hex = hex.toString(16).slice(2);
        }

        hex = hex.replace('#', '');

        const hexAlpha = Math.round(alpha * 255).toString(16);
        const str = `0x${hexAlpha}${hex}`;
        return Number(str);
    }

    static getPathFromUrl = (url: string) => {
        const startIndx = url.lastIndexOf('/') + 1
        const end = url.length
        return url.substring(startIndx, end)
    }

    static getFeedType = (type: string) => {
        switch (type) {
            case ACTIONTYPE.VIDEO:
                return ACTIONTYPE.VIDEO
            case ACTIONTYPE.CATEGORY:
                return ACTIONTYPE.CATEGORY
            case ACTIONTYPE.CHILDAPP:
                return ACTIONTYPE.CHILDAPP
            case ACTIONTYPE.LIVE:
                return ACTIONTYPE.LIVE
        }
    }

    static secondsToHms = (d: number, isSeconds = false) => {
        const h = Math.floor(d / 3600);
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 3600 % 60);

        const strArray = []
        h > 0 ? strArray.push(h + 'h') : "";
        m > 0 ? strArray.push(m + 'm') : "";

        if (isSeconds) {
            s > 0 ? strArray.push(s + 's') : "";
            return strArray.join(':')
        }
        return strArray.join(':')
    }

    static secondsToDisplayReadyTime = (seconds: any) => {
        if (isNaN(seconds)) {
            seconds = 0;
        }
        return new Date(seconds * 1000).toISOString().substr(11, 8);
    };

    static getScripts = (scripts: string[], defer = ''): Promise<boolean[]> => {
        const promise: Promise<boolean[]> = new Promise((resolve) => {
            const results: boolean[] = []
            const loadingFinishStatus: boolean[] = []
            scripts.map((script, index) => {
                try {
                    const scriptEl: HTMLScriptElement = document.createElement('script');
                    scriptEl.src = script
                    if (defer === 'defer') {
                        scriptEl.defer = true
                    }
                    scriptEl.onload = () => {
                        //console.log('Load script: Success: ', script)
                        loadingFinishStatus.push(true)
                        results[index] = true;
                        if (loadingFinishStatus.length == scripts.length) {
                            resolve(results);
                        }
                    }
                    scriptEl.onerror = () => {
                        //console.log('Load script: Failed: ', script)
                        loadingFinishStatus.push(false)
                        results[index] = false;
                        if (loadingFinishStatus.length == scripts.length) {
                            resolve(results);
                        }
                    }
                    document.body.appendChild(scriptEl)
                } catch (e) {
                    //console.log('Load script: Failed: ', script, e)
                    loadingFinishStatus.push(false)
                    results[index] = false;
                    if (loadingFinishStatus.length == scripts.length) {
                        resolve(results);
                    }
                }
            })
        })
        return promise;
    }

    static resumeScreenButtons = [
        {
            label: "Resume",
            action: "$resume",
            width: 230,
            height: 70
        },
        {
            label: "Play from Beginning",
            action: "$begin",
            src: "svg/playBegin.svg",
            focusedSrc: "svg/hover-playBegin.svg",
            width: 150,
            height: 150
        },

        {
            label: "Like it!",
            action: "$like",
            src: "images/thumb-up.png",
            focusedSrc: "images/hover-thumb-up.png",
            width: 100,
            height: 150
        },
        {
            label: "Love it!",
            action: "$love",
            src: "images/love.png",
            focusedSrc: "images/hover-love.png",
            width: 100,
            height: 150
        },
        {
            label: "Not For Me!",
            action: "$dislike",
            src: "images/thumb-down.png",
            focusedSrc: "images/hover-thumb-down.png",
            width: 100,
            height: 150
        }

    ]
    static moreInfoScreenButtons = [
        {
            label: "Play",
            action: "$begin",
            width: 175,
            height: 70
        },
        {
            label: "Back",
            action: "$back",
            width: 120,
            height: 70
        },
         {
            label: "Like it!",
            action: "$like",
            src: "images/thumb-up.png",
            focusedSrc: "images/hover-thumb-up.png",
            width: 100,
            height: 150
        },
        {
            label: "Love it!",
            action: "$love",
            src: "images/love.png",
            focusedSrc: "images/hover-love.png",
            width: 100,
            height: 150
        },
        {
            label: "Not For Me!",
            action: "$dislike",
            src: "images/thumb-down.png",
            focusedSrc: "images/hover-thumb-down.png",
            width: 100,
            height: 150
        },
    ]
    static moreInfoScreenButtonsMLP = [
        {
            label: "Play",
            action: "$begin",
            width: 175,
            height: 70
        },
        {
            label: "Back",
            action: "$back",
            width: 120,
            height: 70
        },
        {
            label: "Like it!",
            action: "$like",
            src: "images/thumb-up.png",
            focusedSrc: "images/hover-thumb-up.png",
            width: 100,
            height: 150
        },
        {
            label: "Love it!",
            action: "$love",
            src: "images/love.png",
            focusedSrc: "images/hover-love.png",
            width: 100,
            height: 150
        },
        {
            label: "Not For Me!",
            action: "$dislike",
            src: "images/thumb-down.png",
            focusedSrc: "images/hover-thumb-down.png",
            width: 100,
            height: 150
        },
    ]

    static playerControlButtonWidth = 1520
    static buttons = [
        {
            iconsvg: ["ico-player-search"],
            action: "$search",
            tts: 'search',
            sprite: [{ x: 1728, y: 0 }],
            x: 18,
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            // label: "|<",
            //icon: "prev",
            iconsvg: ["ico-prev"],
            action: "$previous",
            tts: 'previous',
            sprite: [{ x: 288, y: 0 }],
            label: "",
            x: (Helper.playerControlButtonWidth / 2) - (144 + 72),
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            //icon: "rewind",
            iconsvg: ["ico-re"],
            sprite: [{ x: 432, y: 0 }],
            action: "$rewind",
            tts: 'rewind',
            label: "",
            x: (Helper.playerControlButtonWidth / 2) - (144),
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            ref: "PlayPause",
            iconsvg: ["ico-play", "ico-pause"],
            sprite: [{ x: 0, y: 0 }, { x: 144, y: 144 }],
            action: "$playPause",
            tts: 'playpause',
            label: "",
            x: Helper.playerControlButtonWidth / 2,
            y: 36,
            //icon: "play",
            iconWidth: 144,
            iconHeight: 144
        },
        {
            //icon: "ffwd",
            iconsvg: ["ico-ff"],
            action: "$forward",
            tts: 'fast forward',
            sprite: [{ x: 576, y: 0 }],
            label: "",
            x: (Helper.playerControlButtonWidth / 2) + 144,
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            // label: ">|",
            // icon: "next",
            iconsvg: ["ico-next"],
            action: "$next",
            tts: 'next',
            sprite: [{ x: 720, y: 0 }],
            label: "",
            x: (Helper.playerControlButtonWidth / 2) + (144 + 72),
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            ref: "ClosedCaption",
            iconsvg: ["ico-cc-off", "ico-cc-on"],
            action: "$closedcaption",
            sprite: [{ x: 1296, y: 0 }, { x: 1584, y: 0 }],
            label: "ClosedCaption",
            tts: 'Closed Caption',
            x: Helper.playerControlButtonWidth - (72 + 18),
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
        {
            iconsvg: ["ico-info"],
            action: "$info",
            tts: 'info',
            sprite: [{ x: 1440, y: 0 }],
            x: Helper.playerControlButtonWidth - 18,
            y: 36,
            iconWidth: 72,
            iconHeight: 72
        },
    ];

    static getCookie = (cname: any) => {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            if (c) {
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    static getFontFamily(fontWeight: string) {
        const { appState } = AppData as AppSetup
        const { appConfig } = appState?.getAppApiConfig()!
        if (appConfig && appConfig.genre.toLocaleLowerCase() == 'kids') {
            return fontWeight + '-kids'
        } else {
            return fontWeight
        }
    }

    static removeCookie = (cname: any, cvalue = '', exdays = 0) => {
        document.cookie = cname + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    }

    static setGeneralCookie = (cname: any, cvalue: any, exdays: any) => {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }

    static isValidValue = (value: any) => {
        return !Helper.isEmpty(value);
    }
    static isEmpty = (value: any) => {
        if (value == null) {
            return true;
        }
        if (value == undefined) {
            return true;
        }
        if (value == '') {
            return true;
        }
        return false;
    }


    static getLogCommonAppParams = () => {
        const { appConfig, platform, appState } = AppData as AppSetup

        let jsonParams = '&auth-token=' + appConfig?.platform_id;
        jsonParams += '&appid=' + platform?.getDeviceId();
        jsonParams += '&appId=9';
        jsonParams += '&version=' + appConfig?.apiVersion;
        jsonParams += '&apptype=' + Helper.getAppType();
        jsonParams += '&siteId=' + appState?.getApp()?.siteId;
        jsonParams += '&format=json';
        jsonParams += '&deviceModel=' + platform?.getFullModel() + '_' + platform?.getPartnerId();
        jsonParams += '&firmware=' + platform?.getFirmwareVersion();
        jsonParams += '&session_id=' + appConfig?.sessionId;
        return jsonParams;

    }

    static getAppType = () => {

        const { appConfig, platform, appState } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()


        var appType = 'iptv-';
        if (appConfig?.platform_id == PLATFORM.LG) {
            appType = 'lgiptv-';
        } else if (appConfig?.platform_id == PLATFORM.VIZIO) {
            appType = 'vizio-';
        } else if (appConfig?.platform_id == PLATFORM.WINDOWS) {
            appType = 'windows-';
        } else if (appConfig?.platform_id == PLATFORM.COMCAST) {
            appType = 'comcast-';
        } else if (appConfig?.platform_id == PLATFORM.COX) {
            appType = 'cox-';
        } else if (appConfig?.platform_id == PLATFORM.ROGERS) {
            appType = 'rogers-';
        } else if (appConfig?.platform_id == PLATFORM.SHAW) {
            appType = 'shaw-';
        } else if (appConfig?.platform_id == PLATFORM.PLATCO) {
            appType = 'platco-';
        } else if (appConfig?.platform_id == PLATFORM.SAMSUNG) {
            appType = 'Samsungiptv-';
        } else if(appConfig?.platform_id == PLATFORM.VIDAA) {
			appType = 'vidaa-';
		}
        if (appApiConfig?.appConfig !== undefined) {
            appType += appApiConfig.appConfig.site_name.replace(/\s+/g, '-').toLowerCase();
        }
        return appType;

    }

    static capitalizeFirstLetter = (str: any, removeSpace: any) => {
        if (removeSpace == true) {
            return str.replace(/\w\S*/g, function (txt: any) {
                return txt.charAt(0).toUpperCase() + txt.substr(1);
            }).replace(/\s/g, "");
        } else {
            return str.replace(/\w\S*/g, function (txt: any) {
                return txt.charAt(0).toUpperCase() + txt.substr(1);
            });
        }
    }

    /**
     * @description Creates GUID for user based on several different browser variables
     */
    static guid = (node_id: any) => {
        const { appConfig } = AppData as AppSetup
        var id = Helper.idGenerator();
        var time = Date.now();
        var tmtx = time.toString();
        var hexa = Math.round(time * Math.random()).toString(16);
        if (Helper.isValidValue(node_id)) {
            var guid = node_id + id + appConfig.buildVersion + hexa;
        } else {
            var guid = id + appConfig.buildVersion + hexa;
        }
        return guid;
    }

    static getRandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    static idGenerator = () => {

        var length = 8;
        var timestamp = +new Date;

        var ts = timestamp.toString();
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < length; ++i) {
            var index = Helper.getRandomInt(0, parts.length - 1);
            id += parts[index];
        }

        return id;

    }

    static resetPageAsNew = () => {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp();
        let ads = app?.ads;
        appState.videoMode = false;
        //appState.player.noVideosStarted = 0;
        //appState.player.noVideosPlayed = 0;
        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;
        appState.player.vodAutoPlayed = false;
        ads.preRollRequestMade = false;
    }

    static preloaderDisplay = (action: any, msg = '') => {
        Logger.printLog('data', '... preloaderDisplay ... action: ', action);
        /*if (action == 'hide') {
          if (appUIConfig.animateRows == true) {
            $('.preloader').animate({ 'opacity': 0 }, 500, function () { });
            setTimeout(function () {
              $('.preloader').hide();
            }, 500);
          } else {
            setTimeout(function () {
              $('.preloader').hide();
            }, 200);
          }
          // $('.preloader').slideUp();
        } else if (action == 'show') {
          if (appUIConfig.animateRows == true) {
            if (platform_id == 1217557) {
              setTimeout(function () {
                $('.preloader').show();
              }, 500);
              $('.preloader').animate({ 'opacity': 1 }, 500, function () { });
            }
            $('.preloader').animate({ 'opacity': 1 }, 500, function () { });
            $('.preloader').show();
          } else {
            $('.preloader').show();
            if(msg !== '') {
              $('.preloader h4').html(msg);
            }
          }
        }
        if (appUIConfig.animateRows == true) {
          $('.preloader').css('top', $(document).scrollTop());
        }*/
    }

    static compare = (a, b) => {
        var priorityA = Number(a.priority || 0);
        var priorityB = Number(b.priority || 0);

        if (priorityA < priorityB) {
            return 1;
        }
        if (priorityA > priorityB) {
            return -1;
        }
        return 0;
    }


    static getMaskedIp = (ip: any) => {
        if (!ip || ip == '') return '';
        var ipArr = [];
        var sColon = ip.indexOf(':');
        var maskedArr = [];
        if (sColon > -1) {
            //is ipv6

            var expIpAddress = Helper.expandIPv6Address(ip); //expand the real address
            ipArr = expIpAddress.split(':');
            for (var i = 0; i < 3; i++) {   //push the first 48 bit
                maskedArr.push(ipArr[i]);
            }
            var maskedIp = maskedArr.join(':') + '::';
            expIpAddress = Helper.expandIPv6Address(maskedIp); //expand the updated masked address
            return Helper.compIPV6(expIpAddress); //then compress and return the masked ip.
        } else if (ip.indexOf('.') > -1) {
            //is ipv4
            ipArr = ip.split('.');
            ipArr.pop();
            ipArr.push('0');
            return ipArr.join('.');
        }
    }

    static expandIPv6Address = (address) => {
        var fullAddress = "";
        var expandedAddress = "";
        var validGroupCount = 8;
        var validGroupSize = 4;

        var ipv4 = "";
        var extractIpv4 = /([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})/;
        var validateIpv4 = /((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})/;

        // look for embedded ipv4
        if (validateIpv4.test(address)) {
            groups = address.match(extractIpv4);
            for (var i = 1; i < groups.length; i++) {
                ipv4 += ("00" + (parseInt(groups[i], 10).toString(16))).slice(-2) + (i == 2 ? ":" : "");
            }
            address = address.replace(extractIpv4, ipv4);
        }

        if (address.indexOf("::") == -1) // All eight groups are present.
            fullAddress = address;
        else // Consecutive groups of zeroes have been collapsed with "::".
        {
            var sides = address.split("::");
            var groupsPresent = 0;
            for (var i = 0; i < sides.length; i++) {
                groupsPresent += sides[i].split(":").length;
            }
            fullAddress += sides[0] + ":";
            for (var i = 0; i < validGroupCount - groupsPresent; i++) {
                fullAddress += "0000:";
            }
            fullAddress += sides[1];
        }
        var groups = fullAddress.split(":");
        for (var i = 0; i < validGroupCount; i++) {
            while (groups[i].length < validGroupSize) {
                groups[i] = "0" + groups[i];
            }
            expandedAddress += (i != validGroupCount - 1) ? groups[i] + ":" : groups[i];
        }
        return expandedAddress;
    }

    static compIPV6 = (address) => {
        return address.replace(/\b:?(?:0+:?){2,}/, '::');
    }

    /**
     * Replace the last 4 characters of an IAB standard Ad ID (UUID) with "0000".
     *
     * @param {string} adId - The original Ad ID (UUID format).
     * @returns {string} - The modified Ad ID with the last 4 characters replaced by "0000".
     *     
     */
    static getSyntheticAdId = (adId) => {
        if (!adId || adId == '') return '';
        if (adId.length < 4) return '';
        // Slice everything except the last 4 chars, and append "0000"
        return adId.slice(0, -4) + "0000";
    }

    static getCdnPath(url): string {
        if (url == "") {
            return ""
        }
        const domain = new URL(url);
        const _url = domain.protocol + '//' + domain.host + '/';
        return _url;
    }

    /**
    * Extracts the value of the specified query parameter from the given URL.
    * 
    * @param {string} url - The URL to extract the query parameter from.
    * @param {string} paramName - The name of the query parameter to extract.
    * @returns {string|null} - The value of the query parameter if it exists, or null if not found.
    */
    static getQueryParamValueFromUrl(url: string, paramName: string) {
        try {
            let search = "";
            if (!url) {
                return "";
            }
            if (url.indexOf("https://") > -1 || url.indexOf("http://") > -1) {
                // Create a new URL object from the given URL
                const urlObj = new URL(url);
                search = urlObj.search
            } else {
                if (url.indexOf("?") > -1) {
                    search = url.split("?")[1];
                }
            }
            // Get the query string part of the URL
            const searchParams = new URLSearchParams(search);
            // Return the value of the query parameter or null if it doesn't exist
            let value = searchParams.get(paramName);
            if (value) {
                return value;
            } else {
                return "";
            }
        } catch (e) {
            return ""
        }
    }

    static isOldDevice = () => {
        const { appConfig, platform } = AppData as AppSetup
        let model = platform?.getFullModel() || '';
        if (model.indexOf('PX') > -1) {
            return 1;
        }
        return 0;
        //model = 'PX051AEI';//WNXI11AEI //PX051AEI //AX061AEI
        //let series =  appConfig?.oldDeviceSeries || [];
        /*return series.reduce(function (previous: any, current: any) {
            return previous + (model.indexOf(current) == -1 ? 0 : 1);
        }, 0);*/
    }

    static getDrmProxyObj = (videoInfo: any) => {
        return new Promise((resolve, reject) => {
            if (videoInfo.drm == 1) {
                const drm = {
                    "com.widevine.alpha": {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.WIDEVINE),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 0,
                    },
                    "com.microsoft.playready": {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.PLAYREADY),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 1,
                    },
                };
                resolve(drm);
            } else {
                resolve(null);
            }
        })
    }

    static getDrmObj = (videoInfo: any) => {
        const { appConfig } = AppData as AppSetup;
        const promise = new Promise((resolve, reject) => {
            if (videoInfo.drm == 1) {
                const url = getDRMURL();
                fetchData(url).then((response: any) => {
                    if (response && response.data) {
                        const drm = {
                            "com.widevine.alpha": {
                                serverURL: appConfig?.drmInfo.widevineLisenceUrl,
                                httpRequestHeaders: {
                                    customdata: response.data.customdata,
                                },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 0,
                            },
                            "com.microsoft.playready": {
                                serverURL: appConfig?.drmInfo.playreadyLisenceUrl,
                                httpRequestHeaders: {
                                    customdata: response.data.customdata,
                                },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 1,
                            },
                        };
                        resolve(drm);
                    } else {
                        resolve(null);
                    }
                });
            } else {
                resolve(null);
            }
        });
        return promise;
    };

    static getYearFrom(releaseDate: string): string {
        if (releaseDate && releaseDate !== '') {
            const dtStr: string = releaseDate.split(' - ')[0]!
            return new Date(dtStr).getFullYear().toString()
        }
        return '';
    }

    /**
     * this function generates a unique session id based on the platform id, site id, device id and unix timestamp
     *
     * @static
     * @returns {string} 
     */
    static generateSessionId(): string {
        const { appConfig, platform } = AppData as AppSetup;
        try {
            const unixTimestampSeconds = Math.floor(Date.now() / 1000);
            const platform_id = appConfig.platform_id
            const siteId = appConfig.siteId
            const deviceId = platform?.getDeviceId()
            Log.info('generateSessionId: ', `${platform_id}_${siteId}_${deviceId}_${unixTimestampSeconds}`)
            let sessionId = `${platform_id}_${siteId}_${deviceId}_${unixTimestampSeconds}`
            return sessionId
        } catch (e) {
        }

        return '';
    }

    static getIptvParameterFromUrl(name: string, url: any) {
        let searchUrl = location.search;
        if (url) {
            const tmpUrl = url.split('?')[1];
            searchUrl = '?' + tmpUrl;
        }
        const iptvparameter = searchUrl.replace('?', '').split('&');
        const param = [];
        iptvparameter.map((val, i) => {
            const tmp = val.split('=');
            param[tmp[0]] = tmp[1];
        })
        return param[name];
    }

    static getAcontent() {
        const { appConfig } = AppData as AppSetup
        var acontentStr = localStorage[appConfig.siteId + '-acontent'];
        var acontent = acontentStr == 'false' ? false : true;
        if (!acontentStr) {
            localStorage[appConfig.siteId + '-acontent'] = appConfig.aContent;
            return appConfig.aContent;
        }
        return acontent;
    }

    static setAContent(acontent: boolean) {
        const { appConfig } = AppData as AppSetup
        localStorage[appConfig.siteId + '-acontent'] = acontent;
        appConfig.aContent = acontent;
    }

    static getPIN() {
        const { appConfig } = AppData as AppSetup
        const currPin = localStorage[appConfig.siteId + '-pin'];
        if (!currPin) {
            return null;
        }
        return currPin;
    }

    static setPIN(pin: string) {
        const { appConfig } = AppData as AppSetup
        const hash = CryptoJS.MD5(pin).toString();
        localStorage[appConfig.siteId + '-pin'] = hash;
    }

    static verifyPIN(pin) {
        const { appConfig } = AppData as AppSetup
        const currPin = localStorage[appConfig.siteId + '-pin'];
        let hash = ''
        try {
            hash = CryptoJS.MD5(pin).toString();
        } catch (e) {
            console.log(e)
        }
        Log.info('Hashed', hash, currPin)
        return hash === currPin
    }

    /**
     * Subtracts a given number of seconds from each element in the input array.
     * Ensures the first element does not fall below 10.
     *
     * @param {number[]} inputArray - Array of numeric time values.
     * @param {number} seconds - Number of seconds to subtract from each element.
     * @returns {number[]} - New array with seconds subtracted, first value constrained to minimum of 10.     
     */
    static subtractSecondsWithMinimum(inputArray, seconds) {
        /*const offset = seconds;
        return inputArray.map(value => value - offset);*/
        const output = inputArray.map((value, index) => {
            const result = value - seconds;
            // Ensure the first element is not less than 10
            if (index === 0 && result < 10) {
              return 10;
            }
            return result;
          });
          return output;
    }
    /**
     * Sends a VAST ad prefetch request to the provided URL.
     *
     * Parses and validates the XML response, logs appropriate FUSE events,
     * and identifies whether the response contains a valid VAST with ads.
     *
     * @param {string} url - The ad tag URL with macros already replaced.
     * @returns {void}     
     */
    static sendFusePrefetchRequest(url:any) {
        Logger.processUserAction('FUSE_PREFETCH','FUSE_REQUEST');
        fetchData(url, true).then((response: any) => {                        
            if (!response.data) throw new Error('Network response was not ok');
            return response.data;            
        })
        .then(str => {
            if (!str.trim()) throw new Error('Empty response');        
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(str, 'application/xml');        
            const parseError = xmlDoc.querySelector('parsererror');
            if (parseError) {
                Helper.logFuseEvent(url,'EMPTY_RESPONSE');
                //console.error('Invalid XML:', parseError.textContent);
                Logger.processUserAction('FUSE_PREFETCH','EMPTY_RESPONSE');
            } else {
              const vastTag = xmlDoc.querySelector('VAST');
              const ads = xmlDoc.querySelectorAll('Ad');              
              if (vastTag && ads.length > 0) {
                //console.log('Valid VAST with ads');
                Helper.logFuseEvent(url,'VALID_RESPONSE');
                Logger.processUserAction('FUSE_PREFETCH','VALID_RESPONSE');
              } else {
                //console.log('Valid XML but no ads found');
                Helper.logFuseEvent(url,'EMPTY_RESPONSE');
                Logger.processUserAction('FUSE_PREFETCH','EMPTY_RESPONSE');
              }
            }
          })
          .catch(error => {
            console.error('VAST fetch error:', error.message);
          });
          Helper.logFuseEvent(url,'FUSE_REQUEST');
    }

    /**
     * Logs a FUSE event by firing a client-side beacon to a logger URL.
     *
     * Includes metadata such as timestamp, event type, platform, and session info.
     *
     * @param {string} url - The original ad tag URL (from which query parameters are extracted).
     * @param {string} eventType - The type of FUSE event to log (e.g., 'FUSE_REQUEST', 'VALID_RESPONSE', 'EMPTY_RESPONSE').
     * @returns {void}     
     */
    static logFuseEvent(url:any, eventType:any,adcount:any=0){
        const { appConfig } = AppData as AppSetup;
        //const timestamp = new Date().getTime();
        const timestamp = new Date().toISOString()
        var loggerUrl = url.split('?')[0];
        if(appConfig?.fuseEnv == 'qa'){
            loggerUrl = "http://qa.adtags.ifood.tv/safeads";
        }
        loggerUrl += `?clientlog=1&timestamp=${timestamp}&eventType=${eventType}&platform=${Helper.getPlatform()}&channel=${appConfig.siteId}&podId=${Helper.getQueryParamValueFromUrl(url,'FT_DEDUPE_ID')}&session_id=${Helper.getQueryParamValueFromUrl(url,'FT_SESSION_ID')}&lineitemid=${Helper.getQueryParamValueFromUrl(url,'lineitemid')}` 
        if(eventType=='PREFETCH_VALID_RESPONSE'){
            loggerUrl += `&adcount=${adcount}`;
        }
        fetchData(loggerUrl, true).then((response: any) => {
        });        
    }

    /**
     * Extracts the value of a specific query parameter from a URL.
     *
     * @param {string} url - The full URL containing query parameters.
     * @param {string} paramName - The name of the parameter to extract.
     * @returns {string|null} The value of the parameter if found, otherwise null.     
     */
    static getPlatform() {
        const { appConfig } = AppData as AppSetup;
        var platform = '';
        if (appConfig.platform_id == PLATFORM.LG) {
            platform = "lgiptv";
        }
        if (appConfig.platform_id == PLATFORM.SAMSUNG) {
        platform = "Samsung";
        }
        if (appConfig.platform_id == PLATFORM.WINDOWS) {
        platform = "windows";
        }
        if (appConfig.platform_id == PLATFORM.WINDOWS && appConfig.isXBox == true) {
        platform = "xbox";
        }
        if (appConfig.platform_id == PLATFORM.VIZIO) {
        platform = "vizio";
        }
        if (appConfig.platform_id == PLATFORM.COMCAST) {
        platform = "comcast";
        }
        if (appConfig.platform_id == PLATFORM.FOXXUM) {
        platform = "foxxum";
        }
        if (appConfig.platform_id == PLATFORM.ZEASN) {
        platform = "zeasn";
        }
        if (appConfig.platform_id == PLATFORM.NETGEM) {
        platform = "netgem";
        }
        if (appConfig.platform_id == PLATFORM.NETRANGE) {
        platform = "netrange";
        }
        if (appConfig.platform_id == PLATFORM.PANASONIC) {
        platform = "panasonic";
        }
        if (appConfig.platform_id == PLATFORM.COX) {
        platform = "cox";
        }
        if (appConfig.platform_id == PLATFORM.ROGERS) {
        platform = "rogers";
        }
        if (appConfig.platform_id == PLATFORM.SHAW) {
        platform = "shaw";
        }
        if (appConfig.platform_id == PLATFORM.PLATCO) {
        platform = "platco";
        }
        return platform;
    }

    /**
     * Determines whether Fuse prefetching is enabled for the current app context.
     *
     * Checks the global app configuration and validates the presence of prefetch points.
     *
     * @returns {boolean} `true` if Fuse prefetching is enabled and PF points are available, otherwise `false`.
     *
     * Preconditions:
     * - `AppData` must contain `appConfig.enableFusePrefetch` flag.
     * - `ads.currentVodPFPoints` must be a valid array with at least one element.
     */
    static isFusePrefetchEnabled(){        
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let ads = app?.ads;
        if(appConfig.enableIMAAdPodding && appConfig?.enableFusePrefetch && ads.currentVodPFPoints && ads.currentVodPFPoints.length>0){
            return true
        }
        return false;
    }
    // 	const searchUrl = location.search;
    // 	if (url) {
    // 		const tmpUrl = url.split('?')[1];
    // 		searchUrl = '?' + tmpUrl;
    // 	}
    // 	const iptvparameter = searchUrl.replace('?', '').split('&');
    // 	const param = [];
    // 	iptvparameter.map((val,i)=> {
    // 		var tmp = val.split('=');
    // 		param[tmp[0]] = tmp[1];
    //     })
    // 	return param[name];
    // }

    static normalizeForChromeVox(text) {
        return text
          .replace(/\//g, ' slash ')
          .replace(/\:/g, ' colon ')
          .replace(/(?!\s)\.(?!\s)/g, ' dot ')
          .replace(/-/g, ' dash ')
          .replace(/_/g, ' underscore ');
        }


    static getSiteConfigInfo(
            _siteConfig: {
                ip?: string,
                config?: {
                    enableFuse: {
                        siteIds: string[]
                    },
                    enableFusePrefetch: {
                        siteIds: string[]
                    },
                    enableSecurityToken: {
                        siteIds: string[]
                    },
                    ip?: string,
                    disableCC: {
                        siteIds: string[]
                    },
                    disableAutoplay: {
                        siteIds: string[]
                    },
                    disableTopCarousel: {
                        siteIds: string[]
                    },
                    disableMidCarousel: {
                        siteIds: string[]
                    },
                    disableSelectScreen: {
                        siteIds: string[]
                    }
                }
            }
        ) {
        if (_siteConfig) {
            const { platform, appConfig} = AppData as AppSetup;
            
            if (!appConfig) {
                return;
            }

            if (_siteConfig.ip && _siteConfig.ip !== '') {
                platform._ip = _siteConfig.ip
            }
            
            if (_siteConfig.config
                && _siteConfig.config.enableFuse
                && _siteConfig.config.enableFuse.siteIds
                && _siteConfig.config.enableFuse.siteIds.length > 0) {
                const found = _siteConfig.config.enableFuse.siteIds.find((id) => id == appConfig?.siteId);
                if (found) {
                appConfig.enableIMAAdPodding = true
                } else {
                appConfig.enableIMAAdPodding = false
                }
            } else {
                appConfig.enableIMAAdPodding = false
            }
            
            if (_siteConfig.config
                && _siteConfig.config.enableFusePrefetch
                && _siteConfig.config.enableFusePrefetch.siteIds
                && _siteConfig.config.enableFusePrefetch.siteIds.length > 0) {
                const found = _siteConfig.config.enableFusePrefetch.siteIds.find((id) => id == appConfig?.siteId);
                if (found) {
                    appConfig.enableFusePrefetch = true
                } else {
                    appConfig.enableFusePrefetch = false
                }
            } else {
                appConfig.enableFusePrefetch = false
            }
            if (_siteConfig.config
                && _siteConfig.config.enableSecurityToken
                && _siteConfig.config.enableSecurityToken.siteIds
                && _siteConfig.config.enableSecurityToken.siteIds.length > 0) {
                const found = _siteConfig.config.enableSecurityToken.siteIds.find((id) => id == appConfig?.siteId);
                if (found) {
                    appConfig.enableSecurityToken = true
                } else {
                    appConfig.enableSecurityToken = false
                }
            } else {
                appConfig.enableSecurityToken = false
            }

            if (_siteConfig.config
                && _siteConfig.config.disableCC
                && _siteConfig.config.disableCC.siteIds
                && _siteConfig.config.disableCC.siteIds.length > 0) {
                const found = _siteConfig.config.disableCC.siteIds.find((id) => id == appConfig?.siteId);
                if (found) {
                    appConfig.disableCC = true
                    appConfig.enableCC = false
                    appConfig.enableCCSettings = false
                }
            }

            if (_siteConfig.config
                && _siteConfig.config.disableAutoplay
                && _siteConfig.config.disableAutoplay.siteIds
                && _siteConfig.config.disableAutoplay.siteIds.length > 0) {
                const found = _siteConfig.config.disableAutoplay.siteIds.find((id) => id == (appConfig?.siteId || 'all'));
                if (found) {
                    appConfig.enableAutoplay = false
                }
            }

            if (_siteConfig.config
                && _siteConfig.config.disableTopCarousel
                && _siteConfig.config.disableTopCarousel.siteIds
                && _siteConfig.config.disableTopCarousel.siteIds.length > 0) {
                const found = _siteConfig.config.disableTopCarousel.siteIds.find((id) => id == (appConfig?.siteId || 'all'));
                if (found) {
                    appConfig.enableTopCarousel = false
                }
            }

            if (_siteConfig.config
                && _siteConfig.config.disableMidCarousel
                && _siteConfig.config.disableMidCarousel.siteIds
                && _siteConfig.config.disableMidCarousel.siteIds.length > 0) {
                const found = _siteConfig.config.disableMidCarousel.siteIds.find((id) => id == (appConfig?.siteId || 'all'));
                if (found) {
                    appConfig.enableMidCarousel = false
                }
            }

            if (_siteConfig.config
                && _siteConfig.config.disableSelectScreen
                && _siteConfig.config.disableSelectScreen.siteIds
                && _siteConfig.config.disableSelectScreen.siteIds.length > 0) {
                const found = _siteConfig.config.disableSelectScreen.siteIds.find((id) => id == appConfig?.siteId);
                if (found) {
                    appConfig.enableSelectScreen = false
                }
            }
            Log.info('PlatformBase: enableIMAAdPodding ', appConfig?.enableIMAAdPodding)
            Log.info('PlatformBase: enableFusePrefetch ', appConfig?.enableFusePrefetch)
            Log.info('PlatformBase: enableSecurityToken ', appConfig?.enableSecurityToken)
            Log.info('PlatformBase: disableCC ', appConfig?.disableCC)
            Log.info('PlatformBase: enableAutoplay ', appConfig?.enableAutoplay)
            Log.info('PlatformBase: enableTopCarousel ', appConfig?.enableTopCarousel)
            Log.info('PlatformBase: enableMidCarousel ', appConfig?.enableMidCarousel)
            Log.info('PlatformBase: enableSelectScreen ', appConfig?.enableSelectScreen)
        }
    }
        
}
